
import { Company } from "@/models/company";
import { AuthService } from "@/services/auth-service";
import Vue from "vue";

export default Vue.extend({
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	computed: {
		tabDefs():{id:number, label:string}[]{
			let result = [
				{id: 0, label: "Account"},
				{id: 1, label: "Users"},
				{id: 2, label: "Dossiers"},
				{id: 3, label: "Modules"},
				{id: 4, label: "Invoices"},
				{id: 5, label: "Subscriptions"}
			];
			if (this.company.WfOfflineID){
				result.push({id: 6, label: "Billing"});
			}
			result.push({id: 7, label: "Referrals"});

			return result;
		},
		tabs():string[]{
			return this.tabDefs.map(t => t.label);
		},
		goBackToCompaniesToolTipText():string {
			return "Back to Accounts";
		},

		currentTabId():number {
			return parseInt(this.$route.query.currentTab as string || "0");
		},
		currentTab():number {
			let index = this.tabDefs.findIndex(t => t.id == this.currentTabId);
			return index < 0 ? 0 : index;
		}
	},
	methods: {
		goBackToCompanies() {
			this.$router.push(`/companies`);
		},

		hasPermission(permission:string):boolean{
			if (!AuthService.user) return false;
			return AuthService.user.hasPermission(permission);
		},
		setTab(value:number){
			let def = this.tabDefs[value];
			if (!def) return;
			this.$router.push(`/companies/${this.company.id}/info?currentTab=${def.id}`);
		}
	}
});
